import { useRef, useEffect } from 'react';

import { Heading, VStack, SimpleGrid, Box } from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';

import Item from './Item';

import useItemPosition from '../../hooks/useItemPosition';
import { ScrollPositionInfo } from '~/hooks/useScroll';

import { ItemInfoProps } from './Item';
import { ChangeCategoryFn, SelectedCategory } from '~/pages/Menu/types';

export type CategoryItemInfo = {
  categoryId: string;
  categoryName: string;
  items: ItemInfoProps[];
};

type CategoryItemListProps = {
  categoryId: string;
  categoryItemInfo: CategoryItemInfo;
  positionInfo: ScrollPositionInfo;
  selectedCategory: SelectedCategory;
  onChangeCategory: ChangeCategoryFn;
  onSaveSelectedCategory: (categoryInfo: SelectedCategory) => void;
};

// 類別品項容器 有切換當前瀏覽類別區塊功能
export default function CategoryItemList({
  categoryId,
  categoryItemInfo,
  positionInfo,
  selectedCategory,
  onChangeCategory,
  onSaveSelectedCategory,
}: CategoryItemListProps) {
  const navigate = useNavigate();

  const categoryRef = useRef<HTMLDivElement>(null);

  const { handleSetItemPosition } = useItemPosition();

  useEffect(() => {
    // When this category is in view place, switch the category
    if (categoryRef.current) {
      const positionTop = categoryRef.current.getBoundingClientRect().top;
      const { clientHeight, scrollTop } = positionInfo;

      const isInPlace = positionTop > clientHeight / 3 && positionTop < clientHeight / 3 + 200;

      isInPlace && onChangeCategory(categoryId, true);
    }
  }, [positionInfo]);

  useEffect(() => {
    if (
      categoryRef.current &&
      selectedCategory.value === categoryId &&
      !selectedCategory.isScrollingChange
    ) {
      const { scrollTop, clientHeight } = positionInfo;
      const positionTop = categoryRef.current.getBoundingClientRect().top;

      window.scrollTo({
        top: positionTop + scrollTop - (clientHeight / 3 + 50),
        behavior: 'smooth',
      });
    }
  }, [selectedCategory, categoryId, categoryRef.current]);

  return (
    <VStack align="stretch" ref={categoryRef}>
      <Heading fontSize="lg">{categoryItemInfo.categoryName}</Heading>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={{ base: 0, md: 10 }} spacingY={2}>
        {categoryItemInfo.items.map((item) => {
          const { itemId, itemName, description, price, imageUrl } = item;
          return (
            <Box key={itemId} py={2} borderBottomWidth="2px" borderColor="wsGray.300">
              <Item
                itemId={itemId}
                itemName={itemName}
                description={description}
                price={price}
                imageUrl={imageUrl}
                onItemPositionChange={handleSetItemPosition}
                onNavigate={() => {
                  onSaveSelectedCategory({
                    isScrollingChange: false,
                    value: categoryItemInfo.categoryId,
                    label: categoryItemInfo.categoryName,
                  });
                  navigate(`item/${item.itemId}`);
                }}
              />
            </Box>
          );
        })}
      </SimpleGrid>
    </VStack>
  );
}
